import Cookies from 'js-cookie';
import { nav } from '@component_path/pages/pc/shared/search_histories';
import {
  currentSuggestType,
  changeBannerImageTagSource,
  closeBanner,
  currentPcrCampaignValue,
  changeBannerClicked,
  isBannerClicked,
  refreshBannerEvents
} from '@component_path/pages/pc/positions/list/search_suggestion_banner.js';

$(() => {
  
  const updateHighlighting = checkbox => {
    checkbox = $(checkbox);
    const label = checkbox.closest('.app-auto-highlight');
    label.toggleClass('m3p_searchfilter-other-checked', checkbox.is(':checked'));
  }
  
  const updateAllHighlighting = () => {
    $('.app-auto-highlight :checkbox').map((_, element) => {
      updateHighlighting(element);
    });
  }
  
  // 給与検索
  const salaryInputRangeIds = [
    {type: 'annual', objId: 'inputRangeAnnualSalary', radioButtonId: 'checkbox_salary'},
    {type: 'hourly', objId: 'inputRangeHourlyWage', radioButtonId: 'checkbox_wage'},
  ];

  const salaryInputRangeEventListener = () => {
    salaryInputRangeIds.forEach((item) => {
      const inputRange = document.getElementById(item.objId);
      const radioButton = document.getElementById(item.radioButtonId);
      if (!inputRange) return;
      inputRange.addEventListener('input', () => {
        bindingForm.updateRangeBar(item);
      });

      if (radioButton && radioButton.checked) {
        bindingForm.updateRangeBar(item);
      }
    });
  };
  
  // p0910の施策でチェックボックスの種類ごとにイベントハンドラを指定しないといけない
  $(document).on('change', '.position-types .app-auto-highlight :checkbox', () => {
    handleBindingPcrCampaign('no_position_type');
    handleBindingPcrCampaign('no_position_type_and_employment_status');
  });
  $(document).on('change', '.employment-types .app-auto-highlight :checkbox', () => {
    handleBindingPcrCampaign('no_employment_status');
    handleBindingPcrCampaign('no_position_type_and_employment_status');
  });
  $(document).on('change', '.app-auto-highlight :checkbox', () => {
    closeBanner();
    updateHighlighting(this);
  });
  
  // ダイアログにdata-urlがあれば、表示時に内容をそこからロード
  $(document).on('show.bs.modal', '.modal', e => {
    const dialog = $(e.currentTarget);
    const url = dialog.data('url');
    if(!url) {
      return;
    }
    dialog.load(url);
  });
  
  const rejectModeParams = params => {
    return $.grep(params, param => {
      const rejects = [
        'search_condition[sm]',
        'search_condition[prefecture_id]',
        'search_condition[city_id_array][]',
        'search_condition[line_id_array][]',
        'search_condition[station_id_array][]',
        'search_condition[nearest_station]',
        'search_condition[commute_time]'
      ];
      return ($.inArray(param.name, rejects) === -1);
    });
  }
  
  /* この条件で求人メールを受け取る */
  const handleClickOnPickupButton = button => {
    nav.putPickupSearchConditionData(button, () => {
      $('.m3p-searchbox__mail_btn').hide();
      $('.m3p-searchbox__mail_btn_selected').addClass('in').show();
      nav.refreshPickUpDataAttr(null)
    }, () => nav.showAlertMessage());
  };
  $(document).on('click', '.m3p-searchbox__mail_btn', e => {
    handleClickOnPickupButton(e.currentTarget);
    return false;
  });
  $('.m3p-searchbox__mail_btn_selected').bind('close.bs.alert', e => {
    $(e.currentTarget).hide();
    return false;
  });
  
  /* 新しい条件で検索した時に求人メールを受け取れるようにする */
  const handleSubmitNewSearchCondition = () => {
    $('.m3p-searchbox__mail_btn').show();
    $('.m3p-searchbox__mail_btn_selected').removeClass('in').hide();
  }

  Number.prototype.numberWithDelimiter = function(delimiter) {
    const number = this + '';
    delimiter = delimiter || ',';
    const split = number.split('.');
    split[0] = split[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      '$1' + delimiter
    );
    return split.join('.');
  };
  
  const updateCount = (count, counterSelector) => {
    const countNode = $(counterSelector);
    let oldCount = parseInt(countNode.text().replace(',', ''));
    if(isNaN(oldCount)) {
      oldCount = count;
    }
    // IE8以前だと実在するcssのスタイルを通してしかanimateできないためダミー要素を作る
    $('<div style="left: ' + oldCount + 'px;"></div>').animate({ left: count }, {
      duration: 500,
      easing: 'linear',
      step(current){
        countNode.text(Math.floor(current).numberWithDelimiter(',') + '件');
      },
      complete(){
        countNode.text(count.numberWithDelimiter(',') + '件');
      }
    });
  }
  
  const refreshSearchCount = (countContainerSelector, setupModeParams) => {
    let params = $('#new_search_condition').serializeArray();
  
    const countContainer = $(countContainerSelector);
  
    params = setupModeParams(params);
    if(params === null) {
      countContainer.text('- 件');
      return;
    }
  
    const url = countContainer.data('url');
    $.getJSON(url, params, data => {
      updateCount(data.count, countContainerSelector);
    }).fail(() => {
      countContainer.text('- 件');
    });
  };
  
  $(document).on('click', '.m3p-search__tab > li', e => {
    const dataName = $(e.currentTarget).data('submit')
    $('.m3p-search__tab__buttons').children(`.app-auto-submit[value="${dataName}"]`).click()
  });
  
  // .app-auto-submitが変更されるとフォームを自動送信
  $(document).on('change', '.app-auto-submit', e => {
    // 〜16時までなど、重複するこだわり条件の選択肢がある。
    // 片方だけチェックボックス外れても、一方のチェックが考慮されて検索されてしまうので、それを防ぐ
    $(`input[type='checkbox'][value='${e.currentTarget.value}']`).prop('checked', e.currentTarget.checked);
    $(e.currentTarget).closest('form').submit();
  });
  
  /* 検索中にローディングアイコンを表示 */ 
  $(document).on('ajax:before', '#new_search_condition', () => {
    $('body').addClass('loading');
  });
  /* 検索完了後にローディングアイコンを隠す */ 
  $(document).on('ajax:complete', '#new_search_condition', (e, xhr, options) => {
    const response = xhr.responseJSON;
    reflectSearchResultToPageView(response);
    handleSubmitNewSearchCondition();
    $('body').removeClass('loading');
  });
  
  /*******************************************
    検索条件(地域モーダル)
    都道府県、市区町村から求人を検索する
  *******************************************/
  
  /* 条件(都道府県、市区町村)に当てはまる求人件数の表示を更新 */
  const refreshAreaSearchCount = () => {
    refreshSearchCount('#area-search-count', params => {
      params = rejectModeParams(params);
      const checkedCities = $('input[type=checkbox]:checked', '#area-search-popup');
      const selectedPrefectureId = $('#select_area_prefecture_id').val();
      const searchMode = () => {
        if(!selectedPrefectureId) {
          return '0';
        } else if(checkedCities.size() === 0) {
          return '1';
        } else {
          return '2';
        }
      }
      const sm = searchMode();
  
      params.push({ name: 'search_condition[sm]', value: sm });
      params.push({ name: 'search_condition[prefecture_id]', value: selectedPrefectureId });
      checkedCities.map((_, element) => {
        params.push({ name: 'search_condition[city_id_array][]', value: $(element).val() });
      });
      return params;
    });
  };
  
  /* モーダルを呼び出す */
  const callAreaSearchModal = () => {
    bindingForm.tab('');
    bindingForm.tab('area');
    const dialog = $('#area-search-popup');
    dialog.load(bindingForm.citiesSearchPath(), () => {
      refreshAreaSearchCount();
      dialog.modal('show');
    });
    return;
  }
  $(document).on('click', '#area-search-button', e => callAreaSearchModal(e));
  /* 条件をリクエストできる形式に組み立てて、検索する */
  $(document).on('click', '#submit-area-search', e => {
    const dialog = $('#area-search-popup');
    const form = $(e.currentTarget).closest('form');
    const prefectureSelect = $('#select_area_prefecture_id');
  
    dialog.on('hidden.bs.modal', () => {
      bindingForm.clearModeParams();
      const searchMode = () => {
        if(prefectureSelect.val() === '') {
          return '0';
        } else if(dialog.find('input:checked').length > 0) {
          return '2';
        } else {
          return '1';
        }
      }
      const sm = searchMode();
      handleBindingPcrCampaign('no_pref');
      handleBindingPcrCampaign('no_city');
      bindingForm.sm(sm);
      bindingForm.prefectureId(prefectureSelect.val());
      bindingForm.cityIdArray($('input:checked', dialog).map((_, element) => $(element).val()));
      bindingForm.tab('area');
      form.submit();
      closeBanner();
      dialog.unbind('hidden.bs.modal');
    });
    dialog.modal('hide');
  });
  /* チェックボックスに変化が出るたびに求人件数の表示を更新 */
  $(document).on('change', '#area-search-popup input[type=checkbox]', refreshAreaSearchCount);
  
  /*******************************************
    検索条件(路線モーダル)
    路線から求人を検索する
  *******************************************/
  
  /* 条件(路線)に当てはまる求人件数の表示を更新 */
  const refreshLineSearchCount = () => {
    refreshSearchCount('#line-search-count', params => {
      const checkedLines = $(':checkbox:checked', '#station-search-popup');
      if(5 < checkedLines.size()) {
        return null;
      }
  
      params = rejectModeParams(params);
      if(checkedLines.size() <= 0) {
        params.push({ name: 'search_condition[sm]', value: '1' });
        params.push({ name: 'search_condition[prefecture_id]', value: $('#select_station_prefecture_id').val() });
      } else {
        params.push({ name: 'search_condition[sm]', value: '4' });
        checkedLines.map((_, element) => {
          params.push({ name: 'search_condition[line_id_array][]', value: $(element).val() });
        });
      }
      return params;
    });
  };
  
  /* 路線選択時に発生する更新処理をまとめている */
  const onUpdateLineCheckbox = () => {
    const dialog = $('#station-search-popup');
  
    const checked = $(':checkbox:checked', dialog);
    if(checked.size() >= 5) {
      $(':checkbox:not(:checked)', dialog).attr('disabled', 'disabled');
    } else {
      $(':checkbox', dialog).removeAttr('disabled');
    }
  
    const grayout = (checked.size() <= 0);
    $('#station-search-popup02-button').toggleClass('m3-button--default', grayout).toggleClass('m3-button--primary', !grayout);
  
    refreshLineSearchCount();
  };
  
  /* モーダルを呼び出す */
  $(document).on('click', '#line-search-button', e => {
    const button = $(e.currentTarget);
    const dialog = $(button.data('target'));
  
    dialog.load(bindingForm.linesSearchPath(), () => {
      onUpdateLineCheckbox();
      dialog.modal('show');
    });
    return;
  });
  /* 条件をリクエストできる形式に組み立てて、検索する */
  $(document).on('click', '#submit-line-search', e => {
    const form = $(e.currentTarget).closest('form');
    const dialog = $('#station-search-popup');
  
    const checkedLines = $('input:checked', dialog);
    if(5 < checkedLines.size()) {
      return false;
    }
  
    dialog.on('hidden.bs.modal', () => {
      bindingForm.clearModeParams();
      if(checkedLines.size() <= 0) {
        bindingForm.sm('1');
        bindingForm.prefectureId($('#select_station_prefecture_id').val());
      } else {
        bindingForm.sm('4');
        bindingForm.lineIdArray(checkedLines.map((_, element) => $(element).val()));
      }
      bindingForm.tab('line_station');
      form.submit();
      dialog.unbind('hidden.bs.modal');
    });
    dialog.modal('hide');
    return false;
  });
  
  /*******************************************
    検索条件(駅モーダル)
    駅から求人を検索する
  *******************************************/
  
  /* 条件(駅)に当てはまる求人件数の表示を更新 */
  const refreshStationSearchCount = () => {
    refreshSearchCount('#station-search-count', params => {
      params = rejectModeParams(params);
  
      if($(':checkbox:checked', '#station-search-popup02').size() === 0) {
        return null;
      }
  
      params.push({ name: 'search_condition[sm]', value: '4' });
      $('.line-group', '#station-search-popup02').map((_, element) => {
        const lineGroup = $(element);
        const line = $('input.line-id', lineGroup);
        const checkedStations = $('input.station-id:checked', lineGroup);
  
        if(line.is(':checked') || checkedStations.size() > 0) {
          params.push({ name: 'search_condition[line_id_array][]', value: line.val() });
  
          if(!line.is(':checked')) {
            checkedStations.map((_, element) => {
              params.push({ name: 'search_condition[station_id_array][]', value: $(element).val() });
            });
          }
        }
      });
      return params;
    });
  };
  
  /* モーダルを呼び出す */
  $(document).on('click', '#station-search-popup02-button', e => {
    const stationDialog = $($(e.currentTarget).attr('href'));
    const lineDialog = $('#station-search-popup');
  
    const checked = $('input:checked', lineDialog);
    if(checked.size() <= 0 || 5 < checked.size()) {
      return false;
    }
  
    lineDialog.on('hidden.bs.modal', e => {
      const path = stationDialog.data('path');
      const params = $(e.currentTarget).closest('form').serializeArray();
      checked.map((_, element) => {
        params.push({ name: 'line_ids[]', value: $(element).val() });
      });
  
      const url = path + '?' + $.param(params);
      stationDialog.load(url, () => {
        refreshStationSearchCount();
        stationDialog.modal('show');
      });
      lineDialog.unbind('hidden.bs.modal');
    });
    lineDialog.modal('hide');
  
    return false;
  });
  /* 条件をリクエストできる形式に組み立てて、検索する */
  $(document).on('click', '#submit-station-search02', e => {
    const form = $(e.currentTarget).closest('form');
    const dialog = $('#station-search-popup02');
  
    if($('input.line-id:checked', dialog).size() === 0 && $('input.station-id:checked', dialog).size() === 0) return false;
  
    dialog.on('hidden.bs.modal', () => {
      bindingForm.clearModeParams();
      bindingForm.sm('4');
  
      const lineIds = [];
      const stationIds = [];
      $('.line-group', dialog).map((_, element) => {
        const lineGroup = $(element);
        const line = $('input.line-id', lineGroup);
        const checkedStations = $('input.station-id:checked', lineGroup);
  
        if(line.is(':checked') || checkedStations.size() > 0) {
          lineIds.push(line.val());
  
          if(!line.is(':checked')) {
            checkedStations.map((_, element) => {
              stationIds.push($(element).val());
            });
          }
        }
      });
      bindingForm.lineIdArray(lineIds);
      bindingForm.stationIdArray(stationIds);
      bindingForm.tab('line_station');
      form.submit();
      dialog.unbind('hidden.bs.modal');
    });
    dialog.modal('hide');
    return false;
  });
  $(document).on('change', '#select_station_prefecture_id', e => {
    const changed = $(e.currentTarget);
    const params = $(e.currentTarget).closest('form').serializeArray();
    params.push({ name: 'prefecture_id', value: changed.val() });
    params.push({ name: 'change', value: 'true' });
    const url = changed.data('path') + '?' + $.param(params);
  
    $('#station-search-popup').load(url, () => onUpdateLineCheckbox());
  });
  $(document).on('change', '#station-search-popup :checkbox', () => onUpdateLineCheckbox());
  $(document).on('change', '#station-search-popup02 input.line-id', e => {
    const isChecked = $(e.currentTarget).is(':checked');
    $('input.station-id', $(e.currentTarget).closest('.line-group')).prop('checked', isChecked);
    refreshStationSearchCount();
  });
  $(document).on('change', '#station-search-popup02 input.station-id', e => {
    const lineGroup = $(e.currentTarget).closest('.line-group');
  
    if($(e.currentTarget).is(':checked')) {
      if($('input.station-id:not(:checked)', lineGroup).size() === 0) {
        $('input.line-id', lineGroup).prop('checked', true);
      }
    } else {
      $('input.line-id', lineGroup).prop('checked', false);
    }
    refreshStationSearchCount();
  });
  
  /*******************************************
    検索条件(通勤時間)
    最寄り駅と通勤時間から求人を検索する
  *******************************************/
  const submitCommuteTime = e => {
    if($('#search_condition_nearest_station').val() === '') {
      return false;
    }
    bindingForm.clearModeParams();
    bindingForm.sm('5');
    bindingForm.tab('commute_time');
    $(e.currentTarget).closest('form').submit();
  };
  $(document).on('ajaxSuggest_selected', '#search_condition_nearest_station', submitCommuteTime);
  $(document).on('change', '#search_condition_nearest_station', submitCommuteTime);
  $(document).on('change', '#search_condition_commute_time', submitCommuteTime);
  
  $('.app-suggest').each((_, element) => {
    const target = $(element)
    target.ajaxSuggest(target.data('suggest-url'), { bind_to: 'ajaxSuggest_selected' });
  });
  
  // .app-auto-reloadが変更されると指定箇所を自動リロード
  $(document).on('change', '.app-auto-reload', e => {
    const changed = $(e.currentTarget);
    const reloadContainer = $(changed.data('to'));
  
    const params = $(e.currentTarget).closest('form').serializeArray();
    params.push({ name: changed.data('param'), value: changed.val() });
    params.push({ name: 'change', value: 'true' });
    const url = changed.data('path') + '?' + $.param(params);
    reloadContainer.load(url);
  });
  
  /*******************************************
    各htmlテンプレートの再描画・更新処理
    ページ読み込み時、検索条件変更時に発動
  *******************************************/
  
  const updateNewMark = currentDays => {
    $('.position-item').map((_, element) => {
      const positionItem = $(element);
      const updatedDays = positionItem.data('updated-days');
      if((currentDays - updatedDays) < 7) {
        $('.position-metadata', positionItem).prepend('<strong class="text-danger">NEW</strong>&nbsp;');
      }
    });
  }

  const sortHighlightTags = tags => {
    const bothTagsHaveClass = (prevTag, nextTag, targetClass) => ($(prevTag).hasClass(targetClass) && $(nextTag).hasClass(targetClass));
    const bothTagsNotHaveClass = (prevTag, nextTag, targetClass) => (!$(prevTag).hasClass(targetClass) && !$(nextTag).hasClass(targetClass));
    
    const targetClass = 'm3p-joboffer__tag-highlight';
    return tags.sort((prevTag, nextTag) => {
      if(bothTagsHaveClass(prevTag, nextTag, targetClass) || bothTagsNotHaveClass(prevTag, nextTag, targetClass)){
        return $(prevTag).text() > $(nextTag).text() ? -1 : 1
      }else {
        return $(prevTag).hasClass(targetClass) ? -1 : 1
      }
    });
  }
  
  const highlightTags = conditionCodes => {
    $('.position-tag').map((_, element) => {
      const tag = $(element);
      const contain = $.inArray(tag.data('code').toString(), conditionCodes) >= 0;
      tag.toggleClass('m3p-joboffer__tag-highlight', contain);
    });
    $('.m3p-joboffer .m3p-joboffer__taglist ul').map((_, element) => {
      const positionTags = $(element).find('.position-tag');
      $(element).html(sortHighlightTags(positionTags).slice(0, 16));
    });
  }
  
  const reflectSearchResultToPageView = (response) => {
    const refreshPageInfos = (headers) => {
      try { $('title').text(headers.title); } catch(e) {};
      $('meta[name="description"]').attr('content', headers.description);
      $('meta[name="keywords"]').attr('content', headers.keyword);
      $('link[rel="canonical"]').attr('href', headers.canonical_urls);
    }
  
    if(response.hasOwnProperty('pickup_path')){
      $('.pickable-up-search-condition').attr("href", response.pickup_path).show();
      $('.picked-up-search-condition, .m3p-histories__checked').show();
    }else{
      $('.pickable-up-search-condition').hide();
      $('.picked-up-search-condition, .m3p-histories__checked').hide();
    }
    
    const refreshHtmlTemplates = htmlTemplates => {
      $('.m3-breadcrumbs').html(htmlTemplates.breadbrumbs);
      $('#header-title').replaceWith(htmlTemplates.header_title);
      $('#position-list').replaceWith(htmlTemplates.position_list);
      $('#search-result-alert').replaceWith(htmlTemplates.search_result_alert);
      $('#joblist-area-text').replaceWith(htmlTemplates.job_change_situation_description);
      $('#relative-position-lists').replaceWith(htmlTemplates.relative_position_lists);
      $('#search-histories-list').replaceWith(htmlTemplates.search_histories);
      $('#pagination').replaceWith(htmlTemplates.pagination);
      $('#search-suggestion-banner').replaceWith(htmlTemplates.search_suggestion_banner);
    }
  
    refreshPageInfos(response.headers);
    refreshHtmlTemplates(response.templates);
    // P0910の施策で追加
    changeBannerImageTagSource();
    changeBannerClicked(false);
    bindingForm.pcr_campaign('');
    refreshBannerEvents();
    highlightTags(response.nids);
    bindingForm.update(response.form_binding, response.needs_aggs);
    updateAllHighlighting();
    updateNewMark(response.new_mark);
  
    const historyUrl = response.history_url;
    history.pushState && history.pushState(null, null, historyUrl);
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({'event': 'history-change', 'virtual_history_url': historyUrl});
  
    nav.refreshSearchHistoryPickUpButton();
    $("img").lazyload();
    // eopイベント設定
    if (window.eop !== undefined) {
      window.eop.markChildren(document, true);
      window.eop.scan();
    }
  };

  function Form(formData, needsCounts) {
    Object.keys(formData).map(key => {
      this[key] = ko.observable();
    })
    this.needsCounts = ko.observable();
    // 給与検索
    this.salaryType.subscribe(
      () => {
        salaryInputRangeIds.forEach((item) => {
          this.updateRangeBar(item);
        });
      }
    );
    this.update(formData, needsCounts);
  }
  $.extend(Form.prototype, {
    update(formData, needsCounts) {
      Object.keys(formData).map(key => {
        const value = formData[key];
        this[key](value);
      });
      this.needsCounts(needsCounts);
    },
    countOf(name, code){
      return this[name]()[code] || 0;
    },
    hasCode(name, code){
      return $.inArray(code, this[name]()) >= 0;
    },
    clearModeParams(){
      this.sm('0');
      this.prefectureId(null);
      this.cityIdArray([]);
      this.lineIdArray([]);
      this.stationIdArray([]);
      this.tab(null);
    },
    selectedSalaryType(salary_type) {
      return this.salaryType() === salary_type;
    },
    selectedAnnualSalary() {
      return this.salaryType() == 'annual';
    },
    selectedHourlyWage() {
      return this.salaryType() == 'hourly';
    },
    updateRangeBar(item) {
      const inputRange = document.getElementById(item.objId);
      const radioButton = document.getElementById(item.radioButtonId);
      if (!inputRange || !radioButton) return;
      const active = this.selectedSalaryType(item.type);
      radioButton.checked = true;
      if(!active) {
        inputRange.style.background = '';
        inputRange.style.transition = '';
        return;
      }
      const activeColor = '#E2E4E9';
      const inactiveColor = '#40509E';
      const ratio = ((inputRange.value - inputRange.min) / (inputRange.max - inputRange.min)) * 100;      
      inputRange.style.background = `linear-gradient(90deg, ${activeColor} ${ratio}%, ${inactiveColor} ${ratio}%)`;
      inputRange.style.transition = 'background .5s ease';
    },
  });

  const initialData = JSON.parse($('#initial-form-binding').attr('data'));
  const form_binding_json = Object.assign(initialData.form_binding, {
    pcr_campaign: ''
  });
  const needs_aggs_json = initialData.needs_aggs;
  const highlight_tags = initialData.highlight_tags;
  const update_new_mark = initialData.update_new_mark;

  const bindingForm = new Form(form_binding_json, needs_aggs_json);
  highlightTags(highlight_tags);
  ko.applyBindings(bindingForm);
  updateNewMark(update_new_mark);
  updateAllHighlighting();
  salaryInputRangeEventListener();
  // 隠れたこだわり条件がページ読み込み時にチェックされている場合、最初から全てのこだわり条件を表示する
  $('.needs-ids .app-auto-highlight.hidden.m3p_searchfilter-other-checked').map(() => showAllNeedsIds());

  // P910の施策で追加
  const handleBindingPcrCampaign = suggestType => {
    if(isBannerClicked() && suggestType === currentSuggestType()){
      bindingForm.pcr_campaign(currentPcrCampaignValue());
      Cookies.set('pcr_campaign', currentPcrCampaignValue());
    }
  }
  const scrollToPositionTypeCheckboxSection = e => {
    const positionTypeCheckboxSection = document.getElementById('checkbox-position-types');
    window.scroll({
      top: positionTypeCheckboxSection.offsetTop,
      behavior: 'smooth'
    });
  }

  const scrollToEmploymentTypeCheckboxSection = e => {
    const employmentTypeCheckboxSection = document.getElementById('checkbox-employment-types');
    window.scroll({
      top: employmentTypeCheckboxSection.offsetTop,
      behavior: 'smooth'
    });
  }
  $(document).on('click', '#suggest-banner-image', e => {
    e.preventDefault();
    changeBannerClicked(true);
    switch(currentSuggestType()){
      case 'no_pref':
        // 都道府県
        callAreaSearchModal();
        return;
      case 'no_city':
        // 市区町村
        callAreaSearchModal();
        return;
      case 'no_position_type_and_employment_status':
        // 業種・雇用形態
        scrollToPositionTypeCheckboxSection();
        return;
      case 'no_position_type':
        // 業種
        scrollToPositionTypeCheckboxSection();
        return;
      case 'no_employment_status':
        // 雇用形態
        scrollToEmploymentTypeCheckboxSection();
        return;
      default:
        return;
    }
  });

  $(document).on('click', 'label[for="checkbox_salary"], label[for="checkbox_wage"]', function(e) {
    const input = document.getElementById(this.getAttribute('for'));
    if(input.checked) {
      e.preventDefault();
      input.checked = false;
      $(e.currentTarget)
        .closest('form')
        .submit();
    }
  });
});
